import {
  Component,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { environment } from "environments/environment";

declare var gapi;

@Component({
  selector: "ga-chart",
  templateUrl: "./ga-chart.component.html",
})
export class GAChartComponent implements AfterViewInit {
  @ViewChild("chart")
  chartElementRef: ElementRef;

  _query: {};

  chart: any;

  _startDate: string;
  _endDate: string;

  constructor() {}

  @Input()
  set startDate(startDate: string) {
    console.log("start date changed");
    this._startDate = startDate;
    this.updateChart();
  }

  @Input()
  set endDate(endDate: string) {
    this._endDate = endDate;
    this.updateChart();
  }

  @Input()
  set query(query: any) {
    this._query = Object.assign({}, query);
    console.log("date changed", this._query);
    this.updateChart();
  }

  updateChart() {
    if (this.chart) {
      this.chart
        .set({
          query: Object.assign({}, this.query, {
            "start-date": this._startDate,
            "end-date": this._endDate,
          }),
        })
        .execute();
    }
  }

  get query() {
    return this._query;
  }

  ngAfterViewInit(): void {
    this.chart = new gapi.analytics.googleCharts.DataChart({
      reportType: "ga",
      query: Object.assign({}, this.query, {
        "start-date": this._startDate,
        "end-date": this._endDate,
      }),
      chart: {
        type: "LINE",
        container: this.chartElementRef.nativeElement,
        options: {
          width: "100%",
        },
      },
    });
    this.chart.execute();
  }
}
